import { Fragment } from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { ChangePasswordForm } from '../components/forms/ChangePasswordForm'
import { useApp } from '../hooks/useApp'
import { callAxios } from '../hooks/useAxios'
import { ChangePasswordData } from '../types/auth'
import { TopTitle } from '../components/atoms/TopTitle'

export function NewPasswordPage(): React.ReactElement {

  const { t } = useTranslation()
  const app = useApp()
  const { token } = useParams()
  const navigate = useNavigate()

  const onSubmit = (data: ChangePasswordData) => {
    callAxios({
      method: 'POST',
      url: '/auth/new-password',
    }, { ...data, token }).then(res => {
      if (res.success) {
        app.addInfo(t('Password has been set. You can now log in.'))
        navigate('/login')
      } else {
        app.addError(res)
      }
    })
  }

  return (
    <Fragment>
      <TopTitle title={t('Set New Password')}/>
      <Box>
        <ChangePasswordForm onSubmit={onSubmit}/>
      </Box>
    </Fragment>
  )
}
